import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQuery, transformResponse } from "../../common/services/api";
import { ConsignmentStockResponse } from "../vo/ConsignmentStock";

export const consignmentStockApi = createApi({
  reducerPath: `consignmentStockApi`,
  baseQuery: createBaseQuery("/customer/consignment-stock"),
  tagTypes: ["ConsignmentStock"],
  endpoints: builder => ({
    inventory: builder.query<ConsignmentStockResponse, string>({
      providesTags: ["ConsignmentStock"],
      query: (clientId = "") => `inventory/${clientId}`,
      transformResponse,
    }),
  }),
});

export const { useInventoryQuery } = consignmentStockApi;
